/** Sum of `pick(x)` over a list. */
export const sumBy = <T>(xs: readonly T[], pick: (x: T) => number) => xs.reduce((a, x) => a + pick(x), 0);

/**
 * `item` first, then the list without the entries `drop` matches (the item it replaces), optionally capped.
 * Used for live lists where a newer message about the same thing replaces the older one.
 */
export function prependReplacing<T>(xs: readonly T[], item: T, drop: (x: T) => boolean, max?: number): T[] {
  const next = [item, ...xs.filter((x) => !drop(x))];
  return max === undefined ? next : next.slice(0, max);
}

/** Copy sorted by an ISO timestamp (or any string key), newest / largest first. */
export const newestFirst = <T>(xs: readonly T[], key: (x: T) => string) => [...xs].sort((a, b) => key(b).localeCompare(key(a)));

/** Set `k` as the newest entry of `m` and forget the oldest ones beyond `max` (Maps keep insertion order). */
export function setCapped<K, V>(m: Map<K, V>, k: K, v: V, max: number) {
  m.delete(k);
  m.set(k, v);
  while (m.size > max) m.delete(m.keys().next().value as K);
  return m;
}
